import { computed, type ComputedRef } from 'vue'
import useNavbarTabs, { type NavbarTab } from '@/composables/useNavbarTabs'
import { useI18n } from '@/composables/useI18n'
import RouteNameEnum from '@/router/RouteNameEnum'
import store from '@/store/BookingStore'
import {
    navigateToFlight,
    navigateToTrain,
    navigateToTransfer,
    navigateToOptions,
    navigateToPayment,
    navigateToUserInfo,
} from '@/router/navigate'

function getWidgetBreadcrumbLabel(routeName: string, fallbackLabel: string, t: (key: string) => string): string {
    switch (routeName) {
        case RouteNameEnum.Train:
        case RouteNameEnum.Flight:
            return t('widgetBreadcrumbs.home')
        case RouteNameEnum.OptionsV2:
            return t('widgetBreadcrumbs.summary')
        case RouteNameEnum.UserInfoV2:
            return t('widgetBreadcrumbs.contact')
        case RouteNameEnum.PaymentV2:
            return t('widgetBreadcrumbs.payment')
        default:
            return fallbackLabel
    }
}

export function navigateToFunnelTab(name: string): void {
    if (name === RouteNameEnum.UserInfoV2 && store.getters.getIsWidgetMode) {
        if (store.getters.getWidgetCheckoutMode === 'payment') {
            navigateToPayment()
            return
        }
        navigateToUserInfo()
        return
    }

    switch (name) {
        case RouteNameEnum.Flight:
            navigateToFlight()
            break
        case RouteNameEnum.Train:
            navigateToTrain()
            break
        case RouteNameEnum.Transfer:
            navigateToTransfer()
            break
        case RouteNameEnum.OptionsV2:
            navigateToOptions()
            break
        case RouteNameEnum.PaymentV2:
            navigateToPayment()
            break
        case RouteNameEnum.UserInfoV2:
            navigateToUserInfo()
            break
    }
}

export default function useWidgetFunnelTabs() {
    const { navbarTabs } = useNavbarTabs()
    const { t } = useI18n()

    const widgetFunnelTabs: ComputedRef<NavbarTab[]> = computed(() =>
        navbarTabs.value.map((tab) => ({
            ...tab,
            label: getWidgetBreadcrumbLabel(tab.name, tab.label, t),
        })),
    )

    return {
        navbarTabs,
        widgetFunnelTabs,
        navigateToFunnelTab,
    }
}
